import Vue from 'vue'
import App from './App.vue'
import AppWWW from './AppWWW.vue'
import store from './stores/index'
import approuter from './routers/router'
import wwwrouter from './routers/wwwrouter'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import adminrouter from './routers/adminrouter'
import Param from "@/lib/definition/variables"

const host = window.location.host;
const parts = host.split('.');
const domainLength = 3; // route1.example.com => domain length = 3
const router = () => {
  let routes;
  if (parts.length === (domainLength - 1) || parts[0] === 'www' || Param.Site.routerType === 'www') {
    routes = wwwrouter
  } else if (parts[0] === 'admin') {
    routes = adminrouter
  } else {
    // If you want to do something else just comment the line below
    routes = approuter
  }
  return routes;
}

const getApp = () => {
  let routes;
  if (parts.length === (domainLength - 1) || parts[0] === 'www' || Param.Site.routerType === 'www') {
    return AppWWW
  }
  return App;
}

Vue.config.productionTip = false
new Vue({
  store: store.original,
  router: router(),
  vuetify,
  render: h => h(getApp())
}).$mount('#app')
